import React from 'react';
import { MegaMenuListMobile } from '../MegaMenuListMobile';
import { renderOtherColumn } from '../../../helpers/columnDataUtils';
import {
  MegaMenuNavigationItem,
  MegaMenuColumn,
  ColumnsListItem,
} from '@layouts/MegaMenu/MegaMenu.types';

interface MegaMenuColumnMobileProps {
  nav: MegaMenuNavigationItem;
  i18n: Record<string, string>;
  columnData?: MegaMenuColumn[];
}

export const MegaMenuColumnMobile = ({ columnData = [], nav, i18n }: MegaMenuColumnMobileProps) => {
  const levelRender = (columnList: ColumnsListItem[] | ColumnsListItem[][], level: number) => {
    return (
      <MegaMenuListMobile
        name={nav.Name}
        columnList={columnList}
        i18n={i18n}
        level={level}
        container={nav.ContainerLink}
      />
    );
  };

  const level2 = renderOtherColumn(columnData, 2);
  const level3 = renderOtherColumn(level2, 3);
  const level4 = renderOtherColumn(level3, 4);
  return (
    <div
      className=''
      data-mobile-mm-container-id={nav.ContainerLink}
      data-mobile-mm-container-name={nav.Name}
      id={nav.ContainerLink}
    >
      {levelRender(columnData, 1)}
      {levelRender(level2, 2)}
      {levelRender(level3, 3)}
      {levelRender(level4, 4)}
    </div>
  );
};
